import type { CategoryCode } from '@typings/Category';
import { useAtomValue } from 'jotai';
import React, { useMemo } from 'react';
import { networkAtom } from '../../../../jotai/storefront/storefronts-network-pvrec';
import { NoMoreResults } from '../NoMoreResults';
import { VendorNetworkCategory } from '../VendorNetworkCategory';
import Styles from './styles.scss';

interface VendorNetworkProps {
	onCategoryClick: (categoryCode: CategoryCode) => void;
	contactedIds: Set<string>;
}

export const VendorNetwork: React.FC<VendorNetworkProps> = ({
	onCategoryClick,
	contactedIds,
}) => {
	const vendorNetwork = useAtomValue(networkAtom);
	const availableCategories = useMemo(() => {
		const filtered = [];
		for (const category of vendorNetwork) {
			const { storefrontNetwork, pvRec } = category;
			let hasAvailableVendor = false;

			for (const sf of storefrontNetwork) {
				if (sf.profile?.id && !contactedIds.has(sf.profile.id)) {
					hasAvailableVendor = true;
					break;
				}
			}

			if (!hasAvailableVendor) {
				for (const vendor of pvRec) {
					if (vendor.id && !contactedIds.has(vendor.id)) {
						hasAvailableVendor = true;
						break;
					}
				}
			}

			if (hasAvailableVendor) filtered.push(category);
		}
		return filtered;
	}, [vendorNetwork, contactedIds]);

	if (availableCategories.length < 1) return <NoMoreResults />;

	return (
		<div className={Styles.vendorNetworkCategories}>
			{availableCategories.map(({ categoryCode }) => (
				<VendorNetworkCategory
					key={categoryCode}
					categoryCode={categoryCode}
					onClick={() => onCategoryClick(categoryCode)}
				/>
			))}
		</div>
	);
};
